import type { DocumentSnapshot } from '@capacitor-firebase/firestore'

/**
 * The events of a snapshot not emitted before, oldest first, and the ids to remember for the next.
 *
 * A snapshot holds the newest events. One emitted earlier stays in it until newer events push it
 * out, after which it cannot return, so only the ids of the current snapshot need remembering.
 */
export function unseenEvents<T>(
  snapshots: DocumentSnapshot<T>[],
  seen: ReadonlySet<string>,
): { events: T[]; seen: Set<string> } {
  const oldestFirst = [...snapshots].reverse()

  return {
    events: oldestFirst.flatMap((snap) => (!seen.has(snap.id) && snap.data ? [snap.data] : [])),
    seen: new Set(oldestFirst.map((snap) => snap.id)),
  }
}
